import { TmdxSwitch } from '@ds';
import { useEffect, useState } from 'react';

type TableSwitchProps = {
  isActive: boolean;
  action: () => void;
  isDisabled?: boolean;
};

export const TableSwitch = ({ isActive, action, isDisabled = false }: TableSwitchProps) => {
  const [active, setIsActive] = useState<boolean>(isActive);

  useEffect(() => {
    setIsActive(isActive);
  }, [isActive]);

  const onChange = async () => {
    action();
  };

  return <TmdxSwitch isSelected={active} isDisabled={isDisabled} onValueChange={onChange} />;
};
